<template>
  <Appendix
    title="Phụ lục thiết bị"
    :fields="fieldsTable"
    :actions="actions"
    :excepts="excepts"
    :only="only"
    :items="items"
    :contract="contract"
  >
    <template #row-details="item">
      <DeviceInfoAppendix
        v-if="item.appendixDevice.isRent === true"
        :items="item.appendixDevice.deviceRents"
        :fields="rentsFields"
      >
        <p>
          Tổng tiền cọc: {{ item.appendixDevice.depositTotal | fomatCurrency }}
          <br />
          Tổng tiền thuê/tháng:
          {{ item.appendixDevice.priceRentTotal | fomatCurrency }}
        </p>
      </DeviceInfoAppendix>
      <DeviceInfoAppendix
        v-if="item.appendixDevice.isLend === true"
        :items="item.appendixDevice.deviceInfos"
        :fields="deviceFields"
      >
        <p>Tiền cọc: {{ item.appendixDevice.deposit | fomatCurrency }}</p>
      </DeviceInfoAppendix>
      <DeviceInfoAppendix v-else :items="item.appendixDevice.deviceInfos" :fields="deviceFields" />
      <StoreInfoAppendix :fields="storeTable" :items="item.merchantBusinessAreas" />
      <template v-if="item.statusHandover"
        >Trạng thái xác nhận bàn giao:
        <Status :value="item.statusHandover" :config="Config.statusHandoverList"
      /></template>
      <template v-if="item.policies"
        >Chính sách đi kèm phụ lục:
        <span v-for="(item, index) in item.policies" :key="index">{{
          item | transformData(cfgPolicyContract)
        }}</span></template
      >
    </template>
    <template #file="item">
      <div v-if="item.urlPDF" class="form-detail">
        <UploadMultiple
          :lsData="[item]"
          keyUrl="urlPDF"
          :canUpload="false"
          :title="`File phụ lục ${item.code}`"
          titleTag="h1"
          titleClass="form-inner-heading"
        />
      </div>
      <div v-if="item.files?.length" class="form-detail">
        <UploadMultiple
          :lsData="item.files"
          keyUrl="urlPDF"
          :canUpload="false"
          title="File xác nhận bàn giao"
          titleTag="h1"
          titleClass="form-inner-heading"
        />
      </div>
    </template>
    <template #footer-card="item">
      <PriceProposals
        :appendix-id="item.appendixId"
        @open-new-proposal="handleNewProposal"
        :devicesListAdd="item.appendixDevice.deviceInfos"
      />
    </template>
  </Appendix>
</template>
<script>
  import Config from '@/thirdParty/config'
  import Appendix from './Appendix.vue'
  import DeviceInfoAppendix from './DeviceInfoAppendix.vue'
  import StoreInfoAppendix from './StoreInfoAppendix.vue'
  import UploadMultiple from '@/components/UploadMultiple.vue'
  import PriceProposals from './PriceProposals.vue'
  export default {
    props: {
      actions: {
        type: Function,
      },
      excepts: {
        type: Array,
        default: () => [],
      },
      only: {
        type: Array,
        default: () => [],
      },
      items: {
        type: Array,
        default: () => [],
      },
      cfgPolicyContract: {
        type: Array,
        default: () => [],
      },
      contract: {
        type: Object,
        default: () => {},
      },
    },
    components: {
      Appendix,
      DeviceInfoAppendix,
      StoreInfoAppendix,
      UploadMultiple,
      PriceProposals,
    },
    data() {
      return {
        Config,
        fieldsTable: [
          { key: 'code', label: 'Số phụ lục', class: 'text-left' },
          {
            key: 'time',
            label: 'Thời gian',
            class: 'text-left',
            thStyle: 'min-width: 210px',
          },
          { key: 'numDevices', label: 'SL thiết bị', class: 'text-right' },
          {
            key: 'price',
            label: 'Thành tiền',
            class: 'text-right',
            formatter: value => this.$options.filters.fomatCurrency(value),
          },
          { key: 'state', label: 'Trạng thái', class: 'text-center' },
          { key: 'type', label: 'Hình thức mua TB', class: 'text-center' },
          { key: 'action', label: 'Thao tác', class: 'text-center' },
        ],
        deviceFields: [
          { key: 'displayName', label: 'Tên', class: 'text-left' },
          { key: 'serialNumber', label: 'Mã serial', class: 'text-left' },
          { key: 'mobileUserStr', label: 'Mobile User', class: 'text-left' },
          {
            key: 'totalPrice',
            label: 'Giá bán',
            class: 'text-right',
            formatter: value => this.$options.filters.fomatCurrency(value),
          },
        ],
        rentsFields: [
          {
            key: 'deviceInfo.displayName',
            label: 'Tên thiết bị',
            class: 'text-left',
          },
          {
            key: 'deviceInfo.serialNumber',
            label: 'Mã serial',
            class: 'text-left',
          },
          {
            key: 'deviceInfo.mobileUserStr',
            label: 'Mobile User',
            class: 'text-left',
          },
          { key: 'policyName', label: 'Chính sách', class: 'text-left' },
          {
            key: 'deviceInfo.price',
            label: 'Giá bán',
            class: 'text-right',
            formatter: value => this.$options.filters.fomatCurrency(value),
          },
          {
            key: 'deposit',
            label: 'Tiền cọc',
            class: 'text-right',
            formatter: value => this.$options.filters.fomatCurrency(value),
          },
          {
            key: 'priceRent',
            label: 'Tiền thuê/tháng',
            class: 'text-right',
            formatter: value => this.$options.filters.fomatCurrency(value),
          },
          {
            key: 'revenue',
            label: 'Doanh thu trung bình',
            class: 'text-right',
            formatter: value => this.$options.filters.fomatCurrency(value),
          },
        ],
        storeTable: [
          { key: 'areaName', label: 'Tên' },
          { key: 'typeStore', label: 'Loại cửa hàng' },
          { key: 'areaAddress', label: 'Địa chỉ' },
          {
            key: 'serials',
            label: 'Serials',
            formatter: value => value?.join(', '),
          },
          { key: 'areaUrl', label: 'Ảnh cửa hàng', class: 'text-center' },
        ],
      }
    },
  }
</script>

<style scoped></style>
